import { useEffect, useRef } from "react";

export default function TradingViewWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const container = containerRef.current;
      if (!container) return;

      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
      script.type = "text/javascript";
      script.async = true;
      script.textContent = JSON.stringify({
        colorTheme: "dark",
        isTransparent: false,
        displayMode: "adaptive",
        width: "100%",
        height: "600",
        locale: "en",
        feedMode: "market",
        market: "forex"
      });

      container.innerHTML = "";
      container.appendChild(script);
    }, 100); // Delay ensures DOM settles

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full h-[600px] rounded-lg overflow-hidden bg-black"
    />
  );
}
